import {Component, Input, OnInit} from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import {SETTINGS} from "../../../../core/config/common.settings";
import {convertAmount} from "../../../../core/ult-functions/currency-calculation";
import {getDayNumber} from "../../../../core/ult-functions/date";

@Component({
  selector: 'app-view-accommodation-content',
  templateUrl: './view-accommodation-content.component.html',
  styleUrls: ['./view-accommodation-content.component.scss']
})
export class ViewAccommodationContentComponent implements OnInit {
  @Input() accommodation?: any;
  @Input() currency?: string;
  @Input() pax: any;
  @Input() secondaryCurrency?: string;
  @Input() exchangeRate?: any;
  @Input() itinerary?: any;
  @Input() vatPercentage?: number;

  isPrimaryCurrency = true ;

  protected readonly SETTINGS = SETTINGS;
  protected readonly convertAmount = convertAmount;
  totalCost = 0;
  extraCostTotal = 0;

  constructor(
    private translocoService: TranslocoService
  ) {
  }

  ngOnInit(): void {
    this.totalCost = this.accommodation.totalCost;
    this.extraCostTotal = (this.accommodation?.extraCost ?? []).reduce(
      (sum: number, item: any) => sum + (item.cost ?? 0), 0
    );
    this.isPrimaryCurrency = this.accommodation?.isPrimaryCurrency ?? true;
  }

  getDayWithNum(day: string): string {
    return getDayNumber(day, this.itinerary.tour.startDate, this.itinerary.tour.endDate);
  }

  getVatLabel(): string {
    return this.accommodation?.isTaxed
      ? this.translocoService.translate('itineraries.viewContentModal.accommodation.vatIncluded')
      : this.translocoService.translate('itineraries.viewContentModal.accommodation.vatExcluded');
  }

  getTaxStatusLabel(): string {
    return this.accommodation?.isTaxed
      ? this.translocoService.translate('itineraries.viewContentModal.accommodation.included')
      : this.translocoService.translate('itineraries.viewContentModal.accommodation.excluded');
  }

  getEmptyValue(): string {
    return this.translocoService.translate('itineraries.viewContentModal.common.emptyValue');
  }
}
